import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const editStock = (school, candidate, typeStock, movement) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/stock/edit', {school, candidate, typeStock, movement}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_EDIT_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'STOCK_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}

export const editStockWithCandidates = (school, candidate, typeStock, movement) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/stock/edit', {school, candidate, typeStock, movement}, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_EDIT_WITH_ALL_SUCCESS',
                payload: data
            })
            dispatch({
                type: 'STOCK_RESET_RESULT'
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}

export const getReducedStocksBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/stock/getReducedBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_GET_ALL_SUCCESS',
                payload: data.stocks
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}

export const getStocksBySchool = (school) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/stock/getBySchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_GET_WITH_ALL_SUCCESS',
                payload: data.stocks
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}

export const getStocksByMultiSchool = (school) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/client/stock/getByMultiSchool/' + school, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_GET_WITH_ALL_SUCCESS',
                payload: data.stocks
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}

export const editMultiSchoolStock = (stockData) => async (dispatch) => {
    dispatch({
        type: 'STOCK_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/client/stock/editByMultiSchool', stockData, {
                headers: { auth: sessionStorage.getItem('jwt') }
            }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'STOCK_EDIT_BY_MULTISCHOOL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'STOCK_NOT_LOADING'
        })
    }
}